import './menu-button/duplicate';
import './quick-action/_legacy-delay';

// Import dependencies
import { AutomatorBuilderItem } from '../_base';
import { unsafeCSS, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
// const strings = UncannyAutomatorBackend.logs.components.logItemAction.i18n;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-action' )
export class AutomatorBuilderAction extends AutomatorBuilderItem {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// The item type
	type = 'action';

	/**
	 * Defines the quick actions of this item
	 *
	 * @return {Array} The quick actions
	 */
	get quickActions() {
		return [
			this._templateQuickActionDelay
		];
	}

	/**
	 * The items/actions displayed in the menu (ellipsis icon)
	 *
	 * @return {Array} An array of TemplateResult, each one representing an action
	 */
	get menuItems() {
		return [
			this._templateMenuButtonDelete,
			this._templateMenuButtonDuplicate,
			this._templateMenuButtonSupport
		];
	}

	/**
	 * Creates the button to delay the action
	 *
	 * @return {TemplateResult} The button
	 */
	get _templateQuickActionDelay() {
		return html`
			<uap-builder-item-action-quick-delay
				item-id=${ this.id }
			></uap-builder-item-action-quick-delay>
		`;
	}

	/**
	 * Creates the button that duplicates the action
	 *
	 * @return {TemplateResult} The button
	 */
	get _templateMenuButtonDuplicate() {
		return html`
			<uap-builder-item-action-menu-button-duplicate
				item-id=${ this.id }
				item-code=${ this.code }
				integration-code=${ this.integrationCode }
			></uap-builder-item-action-menu-button-duplicate>
		`;
	}
}
